import React from 'react'

export default function FaceFeature({ scale, verticalOffset }) {
  const transformOrigin = '24.5 7.8'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M27.5702 2.46006C25.8802 2.88006 24.6102 3.10007 24.5202 3.12007C24.4202 3.10007 23.1602 2.89006 21.4702 2.46006C19.7102 2.02006 13.0202 0.020061 0.950195 1.80006L1.17017 4.87007C1.17017 4.87007 2.93021 5.42006 3.15021 7.17006C3.37021 8.93006 3.26016 15.5101 11.1602 15.5101C19.0602 15.5101 20.9602 11.2101 21.9102 9.47007C22.9202 7.64007 23.1202 5.65008 24.5302 5.63008C25.9402 5.65008 26.1302 7.64007 27.1502 9.47007C28.1102 11.2001 30.0002 15.5101 37.9002 15.5101C45.8002 15.5101 45.6902 8.93006 45.9102 7.17006C46.1302 5.41006 47.8902 4.87007 47.8902 4.87007L48.1102 1.80006C36.0202 0.020061 29.3302 2.02006 27.5702 2.46006ZM11.4002 14.6001C4.38021 14.6001 4.1602 8.86008 4.5202 5.57008C4.8902 2.28008 9.61019 2.46006 12.3202 2.46006C16.5702 2.46006 20.9102 3.30007 21.1302 6.37007C21.3502 9.45007 18.4302 14.6001 11.4002 14.6001ZM37.6302 14.6001C30.6102 14.6001 27.6802 9.44007 27.9002 6.37007C28.1202 3.30007 32.4502 2.46006 36.7102 2.46006C39.4202 2.46006 44.1402 2.28008 44.5102 5.57008C44.8702 8.86008 44.6502 14.6001 37.6302 14.6001Z"
        fill="#010101"
        stroke="#010101"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M2.80023 3.94H2.51025C2.25025 3.94 2.03027 3.72999 2.03027 3.45999C2.03027 3.19999 2.24025 2.97998 2.51025 2.97998H2.80023C3.06023 2.97998 3.28027 3.18999 3.28027 3.45999C3.27027 3.72999 3.06023 3.94 2.80023 3.94Z"
        fill="white"
      />
      <path
        d="M46.23 3.94H46.52C46.78 3.94 47 3.72999 47 3.45999C47 3.19999 46.79 2.97998 46.52 2.97998H46.23C45.97 2.97998 45.75 3.18999 45.75 3.45999C45.76 3.72999 45.97 3.94 46.23 3.94Z"
        fill="white"
      />
    </g>
  )
}
